import axiosInstance from '../../../axiosInstance';

const BASE_PATH = '/api/payments/providers';

export const fetchProviders = async () => {
  const response = await axiosInstance.get(BASE_PATH, {
    withCredentials: true,
  });
  return response.data;
};

export const fetchProviderDetail = async (code) => {
  const response = await axiosInstance.get(`${BASE_PATH}/${code}`, {
    withCredentials: true,
  });
  return response.data;
};

export const saveProviderConfig = async (
  code,
  inputValues,
  activate = false
) => {
  const response = await axiosInstance.put(
    `${BASE_PATH}/${code}/config`,
    { input_values: inputValues, activate },
    { withCredentials: true }
  );
  return response.data;
};
